import { Card, CardContent } from "@/components/ui/card";

export const MarketSizeVisualization = () => {
  return (
    <div className="relative h-[600px] flex items-center">
      <div className="flex w-full gap-12">
        {/* Circles Container */}
        <div className="relative w-[500px] h-[500px]">
          <div className="absolute inset-0 rounded-full bg-primary/20" />
          <div className="absolute inset-[15%] rounded-full bg-primary/30" />
          <div className="absolute inset-[30%] rounded-full bg-primary/40" />
        </div>

        {/* Text Container */}
        <div className="flex flex-col justify-center space-y-12">
          <MarketMetric
            value="$1.5T"
            label="TAM"
            description="Global Hotel Industry"
          />
          <MarketMetric
            value="$7.16B"
            label="SAM"
            description="Hospitality Software"
          />
          <MarketMetric
            value="$358M"
            label="Target"
            description="5% Market Share"
          />
        </div>
      </div>
    </div>
  );
};

const MarketMetric = ({
  value,
  label,
  description,
}: {
  value: string;
  label: string;
  description: string;
}) => (
  <div className="space-y-2">
    <div className="text-4xl font-bold text-primary">{value}</div>
    <div className="text-lg font-semibold">{label}</div>
    <div className="text-sm text-muted-foreground max-w-[300px]">
      {description}
    </div>
  </div>
);
